import { render, staticRenderFns } from "./AbkAddToFavoritesButton.vue?vue&type=template&id=bf3dff0a&scoped=true&"
import script from "./AbkAddToFavoritesButton.vue?vue&type=script&lang=js&"
export * from "./AbkAddToFavoritesButton.vue?vue&type=script&lang=js&"
import style0 from "./AbkAddToFavoritesButton.vue?vue&type=style&index=0&id=bf3dff0a&lang=scss&scoped=true&"
import style1 from "./AbkAddToFavoritesButton.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3dff0a",
  null
  
)

export default component.exports